import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { useAuth } from "./AuthContext";
import Whyglobal from "../Components/Whyglobal";
import BuyerSide from "./BuyerSidebuyer";
import "./OnionBuy.css"; // CSS styling for the Aapalam buyers' section

const AlveBuyer = [
  {
    name: "Imran",
    email: "",
    mobileNumber: "8123381743",
    location: "Bangalore, Karnataka",
    date: "03-04-2025",
    lookingFor:
      "Looking for bulk purchase of plastic food containers with 300ml capacity.",
    productOrService: "Plastic Food Containers",
    quantity: 10000,
    unit: "pieces",
    _id: "unique_id_kitchenware_imran",
  },
  {
    name: "K. Lakkaraju",
    email: "",
    mobileNumber: "9490086507",
    location: "Tirupati, Andhra Pradesh",
    date: "04-04-2025",
    lookingFor: "Looking for round plastic food containers in bulk.",
    productOrService: "Round Plastic Food Containers",
    quantity: 1000,
    unit: "pieces",
    company: "SRI LAKSHMI TRADERS",
    _id: "unique_id_kitchenware_lakkaraju",
  },
];

const KitchenwareBuyer = () => {
  const { userId } = useAuth();
  const [userIsPremium, setUserIsPremium] = useState(false);
  const [shownNumbers, setShownNumbers] = useState([]);
  const [leadsViewed, setLeadsViewed] = useState(0);

  useEffect(() => {
    if (!userId) return;

    const storedViewedLeads =
      JSON.parse(localStorage.getItem(`aapalamViewedLeads_${userId}`)) || [];
    setShownNumbers(storedViewedLeads);

    fetch(
      `${process.env.REACT_APP_API_ENDPOINT}/getUserWithPremiumStatus/${userId}`
    )
      .then((response) => response.json())
      .then((data) => {
        setUserIsPremium(data.isPremium);
        setLeadsViewed(data.leadsViewed);
      })
      .catch((error) => {
        console.error("Error fetching user information:", error);
      });
  }, [userId]);

  const toggleNumber = async (index) => {
    if (!userIsPremium) return;

    if (leadsViewed >= 25) {
      alert("You have reached the limit of 25 leads viewed per month.");
      return;
    }

    if (shownNumbers.includes(index)) return;

    const updatedShownNumbers = [...shownNumbers, index];
    setShownNumbers(updatedShownNumbers);

    localStorage.setItem(
      `aapalamViewedLeads_${userId}`,
      JSON.stringify(updatedShownNumbers)
    );

    const buyer = AlveBuyer[index];

    try {
      const response = await fetch(
        `${process.env.REACT_APP_API_ENDPOINT}/incrementLeadsViewed/${userId}`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            buyerName: buyer.name,
            mobileNo: buyer.mobileNumber,
          }),
        }
      );

      if (response.ok) {
        const data = await response.json();
        setLeadsViewed(data.leadsViewed);
      } else {
        const errorData = await response.json();
        console.error("Error incrementing leads viewed:", errorData.error);
      }
    } catch (error) {
      console.error("Error incrementing leads viewed:", error.message);
    }
  };

  return (
    <>
      <div className="container">
        <ol className="breadcrumb">
          <li className="breadcrumb-item">
            <Link to={"/"}>Home</Link>
          </li>
          <li className="breadcrumb-item active">Aapalam Buyers</li>
        </ol>
      </div>
      <div className="containersx">
        <div style={{ width: "200px", padding: "10px" }} className="browsers">
          <h3>Browse by State</h3>
          <ul className="flt-list cust-scroll" id="state-lists">
            <li>
              <Link to="#">All India</Link>
            </li>
            <li>
              <Link to="#">Maharashtra</Link>
            </li>
            <li>
              <Link to="#">Tamil Nadu</Link>
            </li>
            <li>
              <Link to="#">Delhi</Link>
            </li>
            <li>
              <Link to="#">Gujarat</Link>
            </li>
          </ul>
          <ul className="flt-list cust-scroll">
            <h3>All Varieties</h3>
            <ul className="flt-list cust-scroll">
              <li>
                <Link to="#">Hinges</Link>
              </li>
              <li>
                <Link to="#">Door Handles</Link>
              </li>
              <li>
                <Link to="#">Nails & Screws</Link>
              </li>
              <li>
                <Link to="#">Locks & Latches</Link>
              </li>
              <li>
                <Link to="#">Power Tools</Link>
              </li>
            </ul>
          </ul>
        </div>
        <div className="buyers">
          {AlveBuyer.map((buyer, index) => (
            <div key={index} className="buyer-card">
              <h2 style={{ color: "blue" }}>{buyer.lookingFor}</h2>
              <p>
                <strong>Buyer Name:</strong> {buyer.name}
              </p>
              <p>
                <strong>Quantity:</strong> {buyer.quantity} {buyer.unit}
              </p>
              <p>
                <strong>Location </strong> {buyer.location}
              </p>

              <p>
                <strong>Date:</strong> {buyer.date}
              </p>
              <p>
                <strong>Mobile No.:</strong>{" "}
                {userIsPremium
                  ? shownNumbers.includes(index)
                    ? buyer.mobileNumber
                    : "********"
                  : "********"}
              </p>
              <button
                className="detail-btn"
                onClick={() => toggleNumber(index)}
                disabled={!userIsPremium}
              >
                <div className="btns-imp">
                  <Link to={"/login"}>
                    <button className="detailing-btn">View More</button>
                  </Link>
                  <Link to={"/register-Company"}>
                    <button className="regis-btn">Register Now</button>
                  </Link>
                </div>
              </button>
            </div>
          ))}
        </div>
        <BuyerSide />
      </div>
      <Whyglobal />
    </>
  );
};

export default KitchenwareBuyer;
